import { readonly, reactive } from 'vue'

const state = reactive({
  brand: {
    part1: 'no',
    part21: 'p',
    part22: 'ai',
    part23: 'n',
    part3: 'no',
    part4: 'DSA',
    email1: 'No',
    email2: 'Pain',
    email3: 'DSA',
    caption: 'Leo DSA Tuition',
    levels: 'Undergraduate level',
    tuition: 'Leo DSA Tuition',
    email: 'NoPainNoDSA@gmail.com',
    domain: '@gmail.com',
    mail_to: 'mailto:NoPainNoDSA@gmail.com?subject=Regarding DSA tuition...',
  },

  hero: {
    title: `
    Data Structures and Algorithms Made Simple
    `,
    subtitle1: `
    Friendly, focused DSA tuition for VTU, KTU and Anna University courses
    `,
    subtitle2: `
    at student-friendly prices
    `,
    para: `“No Pain No DSA” reflects a simple truth: mastering algorithms takes persistence, struggle, and disciplined thinking. No Pain No DSA helps students turn that challenge into confidence.`
  },

  courses: [
    {
      coursename: 'BSc. Engineering',
      subjects: [
        {
          title: 'Data Structures and Algorithms',
          cover: 'dsa_in.jpg'
        },
      ],
    }
  ],

  features: {
    grouplive: 'Group Live Tuition',
    freefirst: 'Free 1st class',
    nocontract: 'no contract',
    noupfront: 'no upfront fee',
    fee: '₹50 per session',
    duration45: '45-min live teaching',
    duration15: '+ 15-min guided discussion',
    corenum: 'One',
    coreclass: 'weekly core class',
    flexible: 'with flexible catch-up included if missed',
  },

  tutor: {
    name: 'Leo (B.Engg., M.Sc.)',
    degrees: 'B.Engg., M.Sc.',
    about: `
    NoPainNoDSA provides expert DSA tuition for VTU, KTU and Anna University students. Our experienced tutor offers personalised lessons designed to strengthen understanding, boost grades, and build confidence in key DSA topics. Whether you're preparing for exams or looking to master specific areas, NoPainNoDSA is dedicated to helping students achieve their academic goals.
    `,
  },

  fee: {
    bankname: 'Barclays',
    accname: 'Santosh Singh',
    accnum: '3330 7220',
    sortcode: '20-76-90',
    paypal: 'https://www.paypal.me/MathsHour',
  },

  timetable: [
    {
      name: 'Sahni (VTU Textbook-1, KTU Textbook-1) | Schaums (VTU Textbook-2) | Goodrich (Anna University Textbook-1)',
      level: 'Computer Science',
      thumbnail: ['horowitz.jpg', 'seymour.jpg', 'goodrich.jpg'],
      mon: '11am',
      tue: '',
      wed: '11am',
      thu: '',
      fri: '11am',
      sat: '',
      sun: '',
    },
  ],
})

const methods = {
  onLoad() {
    console.log('courses loaded')
  },
}

const getters = {

}

export default {
  state: readonly(state),
  methods,
  getters,
}